import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Box from './Box';
import UnstyledButton from './UnstyledButton';
const StarButton = _ref => {
  let {
    active,
    busy,
    onClick,
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
    onClick: evt => !busy && onClick(evt)
  }), /*#__PURE__*/React.createElement(StarBusyCssKeyframes, null), /*#__PURE__*/React.createElement(Star, {
    active: active,
    busy: busy,
    width: size,
    height: size
  }));
};
const Star = _ref2 => {
  let {
    active,
    busy,
    height,
    width
  } = _ref2;
  return /*#__PURE__*/React.createElement(_StyledBox, {
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    height: height,
    width: width,
    __css: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    $_css: busy && "animation: star-busy 1s linear infinite;"
  }, /*#__PURE__*/React.createElement("path", {
    fill: active ? '#F7D008' : '#acb7ba',
    stroke: active ? '#E1A200' : '#acb7ba',
    fillOpacity: active ? '1' : '.2',
    strokeWidth: "2",
    d: "M14.5 3.2l3.5 7.1.2.5.5.1 7.9 1.1-5.7 5.5-.4.4.1.5 1.3 7.8-7-3.7-.5-.2-.4.2-7 3.7 1.3-7.8.1-.5-.4-.4L2.4 12l7.9-1.1.5-.1.2-.5 3.5-7.1z"
  }));
};
const StarBusyCssKeyframes = createGlobalStyle(["@keyframes star-busy{0%{opacity:1;}50%{opacity:.2;}100%{opacity:1;}}"]);
StarButton.propTypes = {};
StarButton.defaultProps = {
  active: false,
  busy: false,
  size: 16
};
StarButton.displayName = 'StarButton';
export default StarButton;
var _StyledBox = _styled(Box).withConfig({
  displayName: "StarButton___StyledBox",
  componentId: "sc-2c6xic-0"
})(["", ""], p => p.$_css);